module.exports = __webpack_public_path__ + "static/media/title.26f28f5a.png";